<template lang="pug">
  dl
    dt {{tracker.title}}
    dd(v-if="!tracker || tracker.length === 0")
      | {{ noDataMsg }}
    dd(v-else)
      line-chart(:chart-data="datacollection" :options="chartOptions")
      ul.tracker-legend
        li.high {{tracker.positiveLabel}}
        li.low {{tracker.negativeLabel}}
</template>

<script>
import LineChart from '@/components/charts/LineChart.js';
import chartMixin from '@/mixins/chartData.js';
import _ from 'lodash';

export default {
  name: 'TrackerChart',
  props: {
    tracker: {
      type: Object,
      required: false
    },
    noDataMsg: {
      type: String,
      required: true
    }
  },
  components: {
    LineChart
  },
  mixins: [ chartMixin ],
  data() {
    return {
      chartOptions: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: 0,
              suggestedMax: 100
            }
          }]
        }
      }
    };
  },

  computed: {
    datacollection: function() {
      var result = {
        labels: [],
        datasets: [
          {
            label: 'Tracker Scores',
            lineTension: 0.15,
            backgroundColor: 'rgba(0,124,166,0.2)',
            borderColor: 'rgba(0,124,166,0.9)',
            borderWidth: '2',
            pointBackgroundColor: '#fff',
            pointRadius: 4,
            data: []
          }
        ]
      };
      if (this.tracker.trackerEntries.length > 0) {
        let dates = _.map(this.tracker.trackerEntries, 'createdOn');
        result.labels = this.getFormattedDates(dates);
        result.datasets[0].data = _.map(this.tracker.trackerEntries, 'mood');
      }
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
  .tracker-legend {
    margin-top: 0;
    padding: $xs-spacing;
  }

</style>


